import React, { useMemo } from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import { DownloadProgress } from 'components/DownloadingComponent'
import { Worker, Viewer } from '@react-pdf-viewer/core'
import '@react-pdf-viewer/core/lib/styles/index.css'

const PdfPreview = ({ loading, pdfPreview, dataEvent, handleClose }) => {
    const MemoizedViewer = React.memo(({ pdfUrl }) => (
        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
            <Viewer fileUrl={pdfUrl} />
        </Worker>
    ))

    const downloadLink = useMemo(() => {
        const link = document.createElement('a')
        link.href = pdfPreview
        link.download = `Export Event of ${dataEvent.event_name} Responses File.pdf`
        return link
    }, [pdfPreview, dataEvent.event_name])

    return (
        <div className="w-[45%] sm:w-full md:w-[50%] fixed right-0 top-8 bottom-0 z-30 h-screen custom-scroll bg-white animate_move_to_Left shadow-md">
            <div className="w-full flex flex-col items-center justify-between px-5 sticky -top-4 bg-white pt-4 shadow-md">
                {loading ? (
                    <DownloadProgress progress={loading} />
                ) : (
                    <div className="w-full flex items-center justify-between gap-4">
                        <div className="flex gap-2 mt-2">
                            <button
                                onClick={() => {
                                    document.body.appendChild(downloadLink)
                                    downloadLink.click()
                                    document.body.removeChild(downloadLink)
                                }}
                                className="bg-main px-4 py-3 text-white rounded-md text-[.7em]"
                            >
                                Download PDF
                            </button>
                        </div>

                        <p
                            className="text-2xl opacity-70 hover:opacity-100 items-center text-main cursor-pointer"
                            onClick={handleClose}
                        >
                            <AiOutlineCloseCircle />
                        </p>
                    </div>
                )}
                <p className="text-xs text-main pb-2 opacity-70 font-semibold">Preview</p>
            </div>
            <div className="w-full h-[90%] flex items-center justify-center ">
                <MemoizedViewer pdfUrl={pdfPreview} />
            </div>{' '}
        </div>
    )
}

export default PdfPreview
